import naja from 'naja';
import CustomCartSelect from './CustomCartSelect';

export default class Cart {
    private container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.init();
        this.initSnippetListener();
    }

    static init() {
        const container = document.querySelector('.base-cart') as HTMLElement;
        if (container) {
            new Cart(container);
        }
    }

    private init() {
        // Listen for quantity changes (assume .cart-quantity-input is the input/select for quantity)
        this.container.querySelectorAll<HTMLInputElement>('.cart-quantity-input').forEach((input) => {
            input.addEventListener('change', (e) => this.onQuantityChange(e));
        });

        // Listen for pricing select changes from CustomCartSelect component
        this.container.addEventListener('pricingSelectChange', (e) => this.onPricingSelectChange(e));

        // +/- stepper handlers for cart quantity buttons
        this.container.querySelectorAll<HTMLButtonElement>('[data-cart-minus]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const productId = btn.dataset.productId;
                const min = parseInt(btn.dataset.min || '1', 10);
                const input = this.container.querySelector<HTMLInputElement>(
                    `.cart-quantity-input[data-product-id="${productId}"]`,
                );
                if (!input) return;
                const current = parseInt(input.value, 10) || min;
                if (current > min) {
                    input.value = (current - 1).toString();
                    input.dispatchEvent(new Event('change'));
                }
            });
        });

        this.container.querySelectorAll<HTMLButtonElement>('[data-cart-plus]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const productId = btn.dataset.productId;
                const input = this.container.querySelector<HTMLInputElement>(
                    `.cart-quantity-input[data-product-id="${productId}"]`,
                );
                if (!input) return;
                const current = parseInt(input.value, 10) || 1;
                input.value = (current + 1).toString();
                input.dispatchEvent(new Event('change'));
            });
        });
    }

    private onQuantityChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const url = input.dataset.url;
        const quantity = input.value;
        if (!url) return;
        const requestUrl = url.replace(/quantity=\d+/, `quantity=${quantity}`);
        naja.makeRequest('GET', requestUrl, {
            history: false,
        });
    }

    private onPricingSelectChange(event: Event) {
        console.log('Cart: pricingSelectChange event received', event);

        const customEvent = event as CustomEvent;
        const detail = customEvent.detail;

        console.log('Cart: event detail', detail);

        // Find the hidden input to get productOrderId and url
        const container = (event.target as HTMLElement).closest('.select-container');
        if (!container) {
            console.log('Cart: No container found');
            return;
        }

        // Get data from the selected option or from the event detail
        let productOrderId: string | undefined;
        let url: string | undefined;

        if (detail.option) {
            // For regular options, get data from the option element
            productOrderId = detail.option.dataset.productOrderId;
            url = detail.option.dataset.url;
        } else {
            // For custom quantities, try to find data from any option
            const anyOption = container.querySelector('.option[data-product-order-id]') as HTMLElement;
            if (anyOption) {
                productOrderId = anyOption.dataset.productOrderId;
                url = anyOption.dataset.url;
            }
        }

        let quantity: string;
        if (detail.isCustom && detail.quantity) {
            quantity = detail.quantity.toString();
        } else {
            quantity = detail.value;
        }

        console.log('Cart: Making request', { productOrderId, url, quantity });

        if (!productOrderId || !url || !quantity) {
            console.log('Cart: Missing required data', { productOrderId, url, quantity });
            return;
        }

        // Make AJAX request
        const requestUrl = `${url}&productOrderId=${productOrderId}&quantity=${quantity}`;
        console.log('Cart: Request URL', requestUrl);

        naja.makeRequest('GET', requestUrl, {
            history: false,
        });
    }

    private initSnippetListener() {
        naja.snippetHandler.addEventListener('afterUpdate', (event: any) => {
            if (event.detail.snippet.id === 'snippet--cartFormSnippet') {
                const newContainer = document.querySelector('.base-cart') as HTMLElement;
                if (newContainer) {
                    this.container = newContainer;
                }
                CustomCartSelect.init();
                this.init();
            }
        });
    }
}
